import React from 'react'

import {validateField} from './validate/validate'

class Form extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}

    this.onBlur = this.onBlur.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onFinishStep = this.onFinishStep.bind(this)
    this.onChange = this.onChange.bind(this)
    this.changeFieldinFormState = this.changeFieldinFormState.bind(this)
  }

  componentWillMount() {
    let formState = this.props.state.reduce((acc, value) => {
      return {...acc, [value.id]: value}
    }, {})

    this.setState((prevState, props) => {
      return {...prevState, form: formState}
    })
  }

  changeFieldinFormState(fieldName, attrObj) {
    this.setState((prevState, props) => {
      return {...prevState, form: {...prevState.form, [fieldName]: {...prevState.form[fieldName], ...attrObj}}}
    })
  }

  onChange(event) {

    let propName = event.target.dataset.id
    
    let [propAttr, propValue] = this.props.typeRender[this.state.form[propName].type].onChange(event)

    this.changeFieldinFormState(propName, {[propAttr]: propValue})
  }

  onFocus(event) {
    let propName = event.target.dataset.id

    this.changeFieldinFormState(propName, {error: false})
  }

  onBlur(event) {
    let propName = event.target.dataset.id
    let propValue = event.target.value

    let validateArray = validateField(this.state.form[propName].rules, propValue)

    if(validateArray.length !== 0) {
      this.changeFieldinFormState(propName, {error: true, errorMessage: validateArray[0].message})
    }
  }

  onFinishStep(event) {
    let {form} = this.state
    let valid = []
    for(let field in form) {
      let validateArray = validateField(form[field].rules, form[field].value)
      if(validateArray.length !== 0) {
        valid.push({...validateField(form[field].rules, form[field].value)[0], id: field})
      }
    }

    if(valid.length !== 0) {
      valid.forEach(field => {
        this.changeFieldinFormState(field.id, {error: true, errorMessage: field.message})
      })
    } else {
      if(this.props.finalStep) {
        this.props.sendButton(this.state.form)
      } else {
        this.props.saveDataToWizard(this.state.form)
      }
    }
    
  }

  render() {
    let {typeRender} = this.props

    let stateRender = this.props.state.reduce((acc, value) => {
      if(typeRender.hasOwnProperty(value.type)) {

        let component = typeRender[value.type].component
        let propsObj = {
          ...value,
          key: value.id,
          id: value.id,
          value: this.state.form[value.id].value,
          error: this.state.form[value.id].error,
          errorMessage: this.state.form[value.id].errorMessage,
          onChange: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus
        }
        
        return {...acc, [value.id]: React.createElement(component, propsObj, null)}
      }
      return acc
    }, {})
    
    return <this.props.render
             fieldsState={this.props.state}
             fields={stateRender}
             previousButton={this.props.previousButton ? <this.props.previousButton onClick={this.props.previousStep} />: null} 
             nextButton={<this.props.nextButton onClick={this.onFinishStep} />}
             changeFieldinFormState={this.changeFieldinFormState}
             chooseEconomBundle={this.props.chooseEconomBundle}
             chooseOptimalBundle={this.props.chooseOptimalBundle}
             chooseMobileBundle={this.props.chooseMobileBundle}
             chooseManualFeatures={this.props.chooseManualFeatures}
           />
  }
}

export default Form


// WEBPACK FOOTER //
// ./src/formWizard/Form.js